/*
hdx-modal-service.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('modules/shell/widgets/modals/js/services/hdx-modal-service',['jquery', 'angular'], function ($, angular) {
    'use strict';

    /*Helper function to verfity config object*/
    function verifyConfig(config, logger, rootScope, modalCounter) {
        if (!config.templateUrl && !config.template) {
            logger.error('TemplateUrl or template should be defined for modal.');
            return;
        }

        if (!config.scope) {
            config.scope = rootScope.$new();
        } else {
            config.scope = config.scope.$new();
        }

        if (!config.size) {
            config.size = 'md';
        }

        config = setConfigParams(config,modalCounter);
        return true;
    }
    /* verifyCongif Helper */
    function setConfigParams(config,modalCounter){
        config.backdrop = config.backdrop || (config.backdrop === undefined) ? true : false;
        config.animate = config.animate || (config.animate === undefined) ? true : false;
        config.modalClass = config.modalClass || '';
        config.id = config.templateUrl ? config.templateUrl.replace(/\//g, '').replace(/\./g, '') : 'modal' + modalCounter;
        config.keyboard = config.keyboard || (config.keyboard === undefined) ? true : false;
        config.resolve = config.resolve || {};
        return config;
    }

    /*Helper function to get Template*/
    function getRemoteTemplate(config, $http, $templateCache, $q) {
        var prom = $q.defer(), template;


        if (config.template) {
            prom.resolve(config.template);
        } else {
            template = $templateCache.get(config.templateUrl);

            if (template) {
                prom.resolve(template);
            } else {
                $http.get(config.templateUrl, {
                    accept: 'text/html',
                    cache: $templateCache
                }).then(function (res) {
                    prom.resolve(res.data);
                }, function () {
                    prom.reject('Template could not be loaded : ' + config.templateUrl);
                });
            }
        }


        return prom.promise;
    }

    /*Helper function to create API*/
    function createApi(config, result, opened) {

        var api = {
            close: function (data) {
                if (config.$modal) {
                    config.$modal.modal('hide');
                    result.resolve(data);

                    config.scope.$parent.$broadcast('modal-closed');
                }
            },
            dismiss: function (errMsg) {
                if (config.$modal) {
                    config.$modal.modal('hide');
                    result.reject(errMsg);
                    config.scope.$parent.$broadcast('modal-dismissed');
                }
            },
            result: result.promise,
            opened: opened.promise
        };

        config.scope.$close = api.close;
        config.scope.$dismiss = api.dismiss;

        return api;

    }

    /*Helper function to resolve callback promises*/
    function getResolvePromises(config, $q, $injector) {
        var resolvePromArray = [];
        if (config.controller) {
            angular.forEach(config.resolve, function (value) {
                if (angular.isFunction(value) || angular.isArray(value)) {
                    resolvePromArray.push($q.when($injector.invoke(value)));
                }
            });
        }
        return resolvePromArray;

    }


    /*Main function to the service*/
    function modalService($templateCache, $logger, $rootScope, $compile, $http, $q, $controller, $injector) {

        var factory = this;
        var modalCounter = 0;
        factory.modals = {};
        factory.MODAL_MD = '600px';
        factory.MODAL_SM = '400px';
        factory.MODAL_LG = '800px';

        /*Helper function to instantiate controller*/
        function initController(config, resolvedVars) {
            var ctrlLocals = {}, ctrlInstance, resolveIterator = 0;
            if (config.controller) {
                ctrlLocals.$scope = config.scope;
                ctrlLocals.$modalInstance = {
                    close: config.api.close,
                    dismiss: config.api.dismiss,
                    opened: config.api.opened,
                    result: config.api.result
                };

                angular.forEach(config.resolve, function (value, key) {
                    ctrlLocals[key] = resolvedVars[resolveIterator++];
                });
                ctrlInstance = $controller(config.controller, ctrlLocals);
                if (config.controllerAs) {
                    config.scope[config.controllerAs] = ctrlInstance;
                }
            }
        }

        /*Helper function to set width*/
        function setWidth(config, $compiledTemp) {

            switch (config.size) {
            case 'lg' :
                $compiledTemp.css({'width': factory.MODAL_LG, 'max-width': factory.MODAL_LG});
                break;
            case 'sm' :
                $compiledTemp.css({'width': factory.MODAL_SM, 'max-width': factory.MODAL_SM});
                break;
            case 'md' :
                $compiledTemp.css({'width': factory.MODAL_MD, 'max-width': factory.MODAL_MD});
                break;
            default :
                if (/^\s*\d*(px|%)\s*$/.test(config.size)) {
                    $compiledTemp.css({'width': config.size, 'max-width': config.size});
                } else {
                    $compiledTemp.css({'width': factory.MODAL_MD, 'max-width': factory.MODAL_MD});
                }

            }
        }

        /* service returning the object*/
        return {
            open: function (conf) {
                modalCounter++;
                var config = angular.extend({}, conf);
                var verified = verifyConfig(config, $logger, $rootScope, modalCounter),
                    containerTemp = $('<div class="modal" tabindex="-1"><div class="modal-dialog"><div class="modal-content"></div></div></div></div>'),
                    compiledTemp, $body = $('body'), templatePromise, resolvePromise;


                var resultDefered = $q.defer(),
                    openedDefered = $q.defer();

                if (verified) {
                    config.api = createApi(config, resultDefered, openedDefered);
                    resolvePromise = getResolvePromises(config, $q, $injector);


                    if (factory.modals[config.id]) {
                        var preConfig = factory.modals[config.id];
                        $q.all(resolvePromise).then(function (resolved) {
                            initController(config, resolved);
                            compiledTemp = $compile(preConfig.template)(config.scope);
                            preConfig.$modal.find('.modal-content').empty();
                            setWidth(config, preConfig.$modal.find('.modal-dialog'));
                            preConfig.$modal.find('.modal-content').append(compiledTemp);
                            preConfig.$modal.modal('show');
                            config.$modal = preConfig.$modal;
                            config.scope.$on('$destroy', function () {
                                delete factory.modals[config.id];
                                preConfig.$modal.remove();
                            });

                            openedDefered.resolve(config.api);
                        });


                    } else {

                        if (config.animate) {
                            containerTemp.addClass('fade');
                        }
                        containerTemp.addClass(config.modalClass);


                        templatePromise = getRemoteTemplate(config, $http, $templateCache, $q);

                        $q.all([templatePromise].concat(resolvePromise)).then(function (resolvedVars) {

                            config.template = resolvedVars[0];
                            initController(config, resolvedVars.slice(1));

                            compiledTemp = $compile(config.template)(config.scope);

                            setWidth(config, containerTemp.find('.modal-dialog'));
                            containerTemp.attr('id', config.id);

                            containerTemp.find('.modal-content').append(compiledTemp);

                            $body.append(containerTemp);
                            config.$modal = $('#' + config.id);
                            config.$modal.modal(
                                {
                                    show: true,
                                    backdrop: config.backdrop,
                                    keyboard: config.keyboard
                                });
                            var backdrop = $('.modal-backdrop').detach();
                            $body.append(backdrop);

                            config.scope.$on('$destroy', function () {
                                delete factory.modals[config.id];
                                config.$modal.remove();
                            });

                            openedDefered.resolve(config.api);


                            factory.modals[config.id] = config;

                        }, openedDefered.reject);


                    }
                    return config.api;
                } else {
                    throw 'Not wokring';
                }
            }
        };
    }

    modalService.$inject = ['$templateCache', '$log', '$rootScope', '$compile', '$http', '$q', '$controller', '$injector'];

    /*function directive for header template */
    function modalHeaderDirective() {
        return {
            restrict: 'AE',
            template: '<div class="modal-header" ng-transclude></div>',
            transclude: true,
            replace: true
        };
    }

    /*function directive for Footer template */
    function modalFooterDirective() {
        return {
            restrict: 'AE',
            template: '<div class="modal-footer" ng-transclude></div>',
            transclude: true,
            replace: true
        };
    }

    /*function directive for Body template */
    function modalBodyDirective() {
        return {
            restrict: 'AE',
            template: '<div class="modal-body" ng-transclude></div>',
            transclude: true,
            replace: true
        };
    }

    /*Injecting factory & directives in to the module*/
    var module = angular.module('modalAng', []);
    module.factory('$hdxModal', modalService)
        .directive('hdxModalHeader', modalHeaderDirective)
        .directive('hdxModalFooter', modalFooterDirective)
        .directive('hdxModalBody', modalBodyDirective);

    return module;
});


